export const GALLERY_LIST_REQUEST = "GALLERY_LIST_REQUEST";
export const GALLERY_LIST_SUCCESS = "GALLERY_LIST_SUCCESS";
export const GALLERY_LIST_FAIL = "GALLERY_LIST_FAIL";

export const GALLERY_DETAIL_REQUEST = "GALLERY_DETAIL_REQUEST";
export const GALLERY_DETAIL_SUCCESS = "GALLERY_DETAIL_SUCCESS";
export const GALLERY_DETAIL_FAIL = "GALLERY_DETAIL_FAIL";

export const GALLERY_ADD_REQUEST = "GALLERY_ADD_REQUEST";
export const GALLERY_ADD_SUCCESS = "GALLERY_ADD_SUCCESS";
export const GALLERY_ADD_FAIL = "GALLERY_ADD_FAIL";
export const GALLERY_ADD_RESET = "GALLERY_ADD_RESET";

export const GALLERY_UPDATE_REQUEST = "GALLERY_UPDATE_REQUEST";
export const GALLERY_UPDATE_SUCCESS = "GALLERY_UPDATE_SUCCESS";
export const GALLERY_UPDATE_FAIL = "GALLERY_UPDATE_FAIL";
export const GALLERY_UPDATE_RESET = "GALLERY_UPDATE_RESET";

export const GALLERY_DELETE_REQUEST = "GALLERY_DELETE_REQUEST";
export const GALLERY_DELETE_SUCCESS = "GALLERY_DELETE_SUCCESS";
export const GALLERY_DELETE_FAIL = "GALLERY_DELETE_FAIL";
